"use client";
import React, { useEffect, useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);
import "filepond/dist/filepond.min.css";
import Button from "../ui/Button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useAuthInfo from "@/store/auth";
import RegForm from "../partials/auth/reg-from";
import { AjaxPost } from "@/util/Ajax";
import Textinput from "../ui/Textinput";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import Swal from "sweetalert2";
import { useRouter } from "next/navigation";

function ApplyForm({ documents, itemTypeId }) {
  const [files, setFiles] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [errorFiles, setErrorFileFile] = useState("");
  const userData = useAuthInfo((state) => state);
  const router = useRouter();
  const [borrowDetails, setBorrowDetails] = useState({
    amount: 1000,
    months: 12,
  });

  const handleFileUpdate = (documentType, updatedFiles) => {
    setFiles((prevFiles) => ({
      ...prevFiles,
      [documentType]: updatedFiles,
    }));
  };

  // const {
  //   register,
  //   formState: { errors },
  //   handleSubmit,
  //   watch,
  //   setValue,
  // } = useForm({
  //   resolver: yupResolver(currentStepSchema),
  //   // keep watch on all fields
  //   mode: "all",
  // });

  const handleUpload = async (userAuthData) => {
    const missingDocuments = documents.filter(
      (doc) => !files[doc.document] || files[doc.document].length === 0
    );

    if (missingDocuments.length > 0) {
      setErrorFileFile(
        `The following documents are missing: ${missingDocuments
          .map((doc) => doc.document)
          .join(", ")}`
      );
      return;
    }

    setIsLoading(true);
    const uploadedDocuments = Object.keys(files).map((documentType) => {
      const fileItem = files[documentType][0]; // Assuming only one file per document type
      return {
        documentId: documents.find((doc) => doc.document === documentType)
          .documentId,
        serverId: fileItem.serverId, // This should be set during the upload process
      };
    });
    var documentDTO = [];
    uploadedDocuments.forEach((element) => {
      documentDTO.push({
        documentId: element.documentId,
        documentUrl: element.serverId,
      });
    });
    // Send uploadedDocuments to the API

    var res = await AjaxPost(userAuthData, `Apply/Borrow`, {
      documents: documentDTO,
      amount: 1000,
      itemTypeId,
      months: borrowDetails.months,
      amount: borrowDetails.amount,
    });
    if(res.data){
      Swal.fire({
        title: 'Application Submitted',
        text: 'The approval process will take aproximately 1-2 days',
        icon: 'success',
      }).then((result) => {
        router.push('/portfolio')
      })
    }else{
      Swal.fire({
        title: res.response.data.message,
        text: 'Please contact support',
        icon: 'error',
      })
    }
    setIsLoading(false);
  };

  return (
    <div className="w-full">
      <h3 className="text-center md:my-8">The Following Documents are required</h3>
      {documents.map((doc, index) => {
        return (
          <div
            key={doc.id}
            className="flex flex-col md:flex-row w-full justify-between shadow-md p-4 rounded-md my-4 items-center"
          >
            <div className="w-full md:w-1/2">
              <h4>{doc.document}</h4>
              <p>{doc.documentDescription}</p>
            </div>
            <div className="w-full md:w-1/2">
              <FilePond
                files={files[doc.document] || []}
                onupdatefiles={(fileItems) =>
                  handleFileUpdate(doc.document, fileItems)
                }
                allowMultiple={false}
                maxFiles={1}
                maxFileSize="10MB"
                className="my-auto"
                server={{
                  url: "https://eyamweb20240304100030.azurewebsites.net/api/Upload/Document",
                  process: (
                    fieldName,
                    file,
                    metadata,
                    load,
                    error,
                    progress,
                    abort
                  ) => {
                    const formData = new FormData();
                    formData.append("file", file, file.name);
                    const request = new XMLHttpRequest();
                    request.open(
                      "POST",
                      "https://eyamweb20240304100030.azurewebsites.net/api/Upload/Document"
                    );
                    request.upload.onprogress = (e) => {
                      progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                      if (request.status >= 200 && request.status < 300) {
                        // const response = JSON.parse(request.responseText);
                        // const serverId = response.serverId; // Extract serverId from response
                        // file.serverId = serverId; // Store serverId in file object
                        if (errorFiles) {
                          const missingDocuments = documents.filter(
                            (doc) =>
                              !files[doc.document] ||
                              files[doc.document].length === 0
                          );
                          //remove current document from error message
                          const index = missingDocuments.findIndex(
                            (dox) => dox.document === doc.document
                          );
                          if (index > -1) {
                            missingDocuments.splice(index, 1);
                          }

                          if (missingDocuments.length > 0) {
                            setErrorFileFile(
                              `The following documents are missing: ${missingDocuments
                                .map((doc) => doc.document)
                                .join(", ")}`
                            );
                          } else {
                            setErrorFileFile("");
                          }
                        }
                        load(request.responseText);
                      } else {
                        error("Error during Upload!");
                      }
                    };
                    request.send(formData);
                    return {
                      abort: () => {
                        request.abort();
                        abort();
                      },
                    };
                  },
                }}
                name="files"
                labelIdle={`Drag & Drop your ${doc.document} or click to <span class="filepond--label-action">Browse</span>`}
              />
            </div>
          </div>
        );
      })}
      <div className="flex md:flex-row flex-col md:gap-8 gap-4 mb-4">
        <div className="md:w-1/2 fromGroup">
          <Label className="block capitalize form-label " htmlFor="Amount">Amount</Label>
          <Input
            name="Amount"
            label="Amount"
            placeholder="Borrow Amount"
            value={borrowDetails.amount}
            onChange={(e) =>
              setBorrowDetails({ ...borrowDetails, amount: e.target.value })
            }
          />
        </div>
        <div className="md:w-1/2 fromGroup">
          <Label className="block capitalize form-label " htmlFor="Duration">Duration in Months</Label>
          <Input
            name="Duration"
            label="Duration"
            placeholder="Amount of months"
            value={borrowDetails.months}
            onChange={(e) =>
              setBorrowDetails({ ...borrowDetails, months: e.target.value })
            }
          />
        </div>
      </div>
      {!userData.apiToken && (
        <RegForm
          showRegisterButton={false}
          isCheckOut={false}
          isBorrowForm={true}
          onRegisterSuccess={handleUpload}
        />
      )}
      <div>
        {errorFiles && <div className="text-red-500 my-4">{errorFiles}</div>}
        {userData.apiToken && (
          <Button
            icon="heroicons-outline:banknotes"
            text="Borrow"
            onClick={() => {
              handleUpload(userData);
            }}
            className="bg-primary-500 text-white w-full mt-4"
            isLoading={isLoading}
            disabled={isLoading}
          />
        )}
      </div>
    </div>
  );
}

export default ApplyForm;
